/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
// libraries
import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import {
    object, shape, arrayOf, string,
} from 'prop-types';
import { useUIDSeed } from 'react-uid';
import { Link } from 'react-router-dom';

const styles = (theme) => ({
    container: {
        [theme.breakpoints.down('sm')]: {
            maxWidth: theme.palette.tiers.container.maxWidth.downSmall,
            margin: '0 auto',
        },
        [theme.breakpoints.down('md')]: {
            maxWidth: theme.palette.tiers.container.maxWidth.downMedium,
            margin: '0 auto',
        },
        [theme.breakpoints.up('md')]: {
            maxWidth: 1400,
            margin: '0 auto',
        },
        [theme.breakpoints.up('lg')]: {
            maxWidth: 1400,
            margin: '0 auto',
        },
    },
    mainInfoBlock: {
        display: 'flex',
        justifyContent: 'space-around',
        textAlign: 'center',
        margin: '36px 0px',
        [theme.breakpoints.down(769)]: {
            display: 'block',
            margin: '0 60px 20px 60px',
        },
        [theme.breakpoints.down(600)]: {
            display: 'block',
            margin: '10px 5px',
        },
    },
    mainInfoBlockContainer: {
        borderRight: '1px solid #000',
        '&:last-child': {
            borderRight: 0,
        },
        [theme.breakpoints.down(769)]: {
            borderRight: 0,
            borderBottom: '1px solid #000',
            padding: '30px',
            '&:last-child': {
                borderBottom: 0,
            },
        },
        [theme.breakpoints.down(600)]: {
            padding: 10,
            borderBottom: 0,
            borderTop: `1px dotted ${theme.palette.cms?.black || '#000'}`,
            '&:nth-child(2)': {
                borderTop: 0,
            },
            '&:first-child': {
                borderTop: 0,
            },
            '&:nth-child( odd )': {
                borderRight: `1px dotted ${theme.palette.cms?.black || '#000'}`,
            },
        },
    },
    mainInfoBlockTiles: {
        minHeight: '180px',
        padding: '0 70px',
        textAlign: 'center',
        '& img': {
            margin: '0 auto 25px auto',
            display: 'block',
            width: '100px',
            height: '100px',
        },
        [theme.breakpoints.down(768)]: {
            marginBottom: 0,
            padding: '0 40px',
        },
        [theme.breakpoints.down(600)]: {
            padding: 0,
            '& img': {
                margin: '0 auto 10px auto',
            },
        },
    },
    tilesTitle: {
        fontSize: '26px',
        lineHeight: '36px',
        marginBottom: '10px',
        fontFamily: 'PlayfairDisplay, serif',
    },
    tilesSubHeading: {
        fontSize: '14px',
        lineHeight: '20px',
        [theme.breakpoints.down(768)]: {
            fontSize: 14,
        },
        [theme.breakpoints.down(600)]: {
            fontSize: 12,
        },
    },
    title: {
        '& h1, h2, & h3, & h4, & h5, & h6': {
            fontWeight: 'normal',
            fontFamily: 'PlayfairDisplay, serif',
            textAlign: 'center',
            fontSize: '30px',
            [theme.breakpoints.down(769)]: {
                marginBottom: 0,
                fontSize: '26px',
            },
        },
    },
    infoBlockCtaBtn: {
        display: 'inline-block',
        color: 'rgb(255, 255, 255)',
        backgroundColor: 'rgb(34, 139, 34)',
        textDecoration: 'none',
        padding: '0 22px',
        lineHeight: '26px',
        borderRadius: '6px',
        marginTop: '12px',
    },
});
const InfoBlock = ({
    classes, infoBlockData,
}) => {
    if (!infoBlockData) {
        return null;
    }
    const seed = useUIDSeed();
    const infoTilesData = infoBlockData?.tile || [];

    return (
        <Grid container className={classes.container}>
            <Grid item xs={12}>
                <div className={classes.title}><h2>{infoBlockData?.title}</h2></div>
                <div className={classes.mainInfoBlock}>
                    <Grid container>
                        {infoTilesData?.map((tileItem) => {
                            const tileBlockStyle = {
                                backgroundColor: tileItem?.tile_background_color || '#FFFFFF',
                                color: tileItem?.text_color || '#000000',
                            };
                            // for Banner Button
                            const ctaButton = tileItem?.cta_button?.title || '';
                            const ctaButtonURL = tileItem?.cta_button?.href || '';
                            return (
                                <Grid key={seed(tileItem)} item xs={6} md={3} lg={3} className={classes.mainInfoBlockContainer}>
                                    <div className={classes.mainInfoBlockTiles} style={tileBlockStyle}>
                                        <div><img src={tileItem?.desktop_image?.url} alt="Desktop" /></div>
                                        <div className={classes.tilesTitle}>{tileItem?.header}</div>
                                        <div className={classes.tilesSubHeading}>{tileItem?.sub_header}</div>
                                        {ctaButtonURL && (
                                            <Link
                                                className={classes.infoBlockCtaBtn}
                                                to={ctaButtonURL}
                                            >
                                                {ctaButton}
                                            </Link>
                                        )}
                                    </div>
                                </Grid>
                            );
                        })}
                    </Grid>
                </div>
            </Grid>
        </Grid>
    );
};
InfoBlock.propTypes = {
    classes: object,
    infoBlockData: shape({
        tile: arrayOf(
            shape({
                header: string,
                sub_header: string,
                text_color: string,
                tile_background_color: string,
            }),
        ),
    }),
};
InfoBlock.defaultProps = {
    classes: {},
    infoBlockData: {},
};
export default (withStyles(styles)(InfoBlock));
